<div class="profile-education-container public-profile-card" *ngIf="showCard">
    <div class="card-container">
        
        <!-- Card -->
        <mat-card *ngIf="finishLoading">

            <!-- Header -->
            <mat-card-header>
                <mat-icon fontSet="phr-iconset" class="phr-iconset-education"></mat-icon>
                <span class="header-title">{{ 'publicProfiles.education.headerTitle' | translate:locale.language }}</span>            
            </mat-card-header>
            
            <div class="header-separator"></div>

            <!-- Content -->
            <mat-card-content class="">
               
                <div class="description-item" *ngIf="publicProfile.titles && publicProfile.titles.length > 0">
                    <div class="item-title">{{ 'publicProfiles.education.titles' | translate:locale.language }}</div>
                    <span class="item-description">
                        <div class="item" *ngFor="let item of publicProfile.titles; index as i;">
                            <span class="title">{{item.nombre}}</span> <br />
                            <span *ngIf="item.institucion">{{item.institucion}}.</span> {{getFormatedDate(item)}}
                        </div>
                    </span>
                </div>
                <div class="description-item" *ngIf="publicProfile.subEspecialidad">
                    <div class="item-title">{{ 'publicProfiles.education.subspecialty' | translate:locale.language }}</div>
                    <span class="item-description">
                        <span class="title">{{getDetailsAsString(publicProfile.subEspecialidades)}}</span>
                    </span>
                </div>
                <div class="description-item" *ngIf="publicProfile.curses && publicProfile.curses.length > 0">
                    <div class="item-title">{{ 'publicProfiles.education.courses' | translate:locale.language }}</div>
                    <div class="item-description">
                        <div class="item" *ngFor="let item of publicProfile.curses; index as i;">
                            <span class="title">{{item.nombre}}</span> <br />
                            <span *ngIf="item.institucion">{{item.institucion}}.</span> {{getFormatedDate(item)}}
                        </div>
                    </div>
                </div>
                <div class="description-item" *ngIf="publicProfile.entrenamientos && publicProfile.entrenamientos.length > 0">
                    <div class="item-title">{{ 'publicProfiles.education.trainings' | translate:locale.language }}</div>
                    <div class="item-description">
                        <div class="item" *ngFor="let item of publicProfile.entrenamientos">
                            <span class="title">{{item.nombre}}</span> <br />
                            <span *ngIf="item.institucion">{{item.institucion}}.</span> {{getFormatedDate(item)}}
                        </div>
                    </div>
                </div>
                
            </mat-card-content>

        </mat-card>

        <!-- Skeleton -->
        <mat-card class="skeleton-card" *ngIf="!finishLoading">
            <mat-card-header>
                <span class="header-title">
                    <ngx-skeleton-loader [theme]="{ 'width': '190px', 'height': '17px', 'background-color': 'rgb(231, 231, 232)', 'border-radius': '2px', 'margin-bottom': '0px'}"></ngx-skeleton-loader>         
                </span>
            </mat-card-header>
            
            <div class="header-separator"></div>
            
            <mat-card-content class="">

                <!-- Titles -->
                <div class="description-item">
                    <div class="item-title">
                        <ngx-skeleton-loader [theme]="{ 'width': '90px', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                    </div>
                    <span class="item-description">
                        <div>
                            <ngx-skeleton-loader [theme]="{ 'width': '50%', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                        </div> 
                        <div>
                            <ngx-skeleton-loader [theme]="{ 'width': '34%', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                        </div>                        
                    </span>
                </div>

                <!-- Subspecialties -->
                <div class="description-item">
                    <div class="item-title">
                        <ngx-skeleton-loader [theme]="{ 'width': '110px', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                    </div>
                    <span class="item-description">
                        <div>
                            <ngx-skeleton-loader [theme]="{ 'width': '60%', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                        </div> 
                        <div>
                            <ngx-skeleton-loader [theme]="{ 'width': '50%', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                        </div> 
                    </span>
                </div>

                <!-- Courses -->
                <div class="description-item">
                    <div class="item-title">
                        <ngx-skeleton-loader [theme]="{ 'width': '110px', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                    </div>
                    <span class="item-description">
                        <div>
                            <ngx-skeleton-loader [theme]="{ 'width': '68%', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                        </div> 
                        <div>
                            <ngx-skeleton-loader [theme]="{ 'width': '44%', 'height': '16px', 'background-color': 'rgba(83, 86, 90, 0.14)' }"></ngx-skeleton-loader>
                        </div> 
                    </span>
                </div>
            </mat-card-content>
        </mat-card>

    </div>    
</div>



